import { useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { CustomerCardStoreState } from '../types';

/**
 * Pre-typed useSelector bound to CustomerCardStoreState.
 * Use this instead of the generic useSelector inside the activity
 * so selectors can be passed directly without an explicit state annotation:
 *
 *   const buyer = useCustomerCardSelector(customerCardSelectors.getBuyer);
 */
export const useCustomerCardSelector: TypedUseSelectorHook<CustomerCardStoreState> = useSelector;
